import { Link } from "react-router-dom"

import GuestLayout from "../components/GuestLayout"
import HomeDeals from "../components/HomeDeals"
import HomeProdcuts from "../components/HomeProducts"

import "./Home.css"

const Home = () => {
  return (
    <GuestLayout
      header={true}
      footer={true}
    >
      <main id="home">
        <section id="hero" className="py-3 p-sm-0">
          <div className="container">
            <div className="row">
              <div className="col-lg-7">
                <div className="card border-0 rounded-5 text-dark">
                  <div className="card-body p-4 p-md-5">
                    <p className="bg-theme-light d-inline-block px-3 rounded-pill lead text-theme">Sounds Clean</p>
                    <h1 className="fw-bold">Your Trusted Partner<br />for Everyday Essentials</h1>
                    <p className="text-muted">Phonics is the place where you can find all of your household needs. We offer General, Kitchen, Washroom & Bathroom stuff.</p>

                    <Link to="/#deals" className="btn btn-lg btn-theme">Explore Products</Link>

                    <div className="row g-3 g-sm-0 mt-3 mt-sm-4">
                      <div className="col-6 col-sm-3">
                        <div className="d-flex gap-2 align-items-center">
                          <i className="fas fa-check-circle fs-4 text-theme-secondary"></i>
                          <p className="text-body-tertiary m-0">General</p>
                        </div>
                      </div>
                      <div className="col-6 col-sm-3">
                        <div className="d-flex gap-2 align-items-center">
                          <i className="fas fa-check-circle fs-4 text-theme-secondary"></i>
                          <p className="text-body-tertiary m-0">Kitchen</p>
                        </div>
                      </div>
                      <div className="col-6 col-sm-3">
                        <div className="d-flex gap-2 align-items-center">
                          <i className="fas fa-check-circle fs-4 text-theme-secondary"></i>
                          <p className="text-body-tertiary m-0">Washroom</p>
                        </div>
                      </div>
                      <div className="col-6 col-sm-3">
                        <div className="d-flex gap-2 align-items-center">
                          <i className="fas fa-check-circle fs-4 text-theme-secondary"></i>
                          <p className="text-body-tertiary m-0">Bathroom</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-5"></div>
            </div>
          </div>
        </section>

        <HomeDeals />
        <HomeProdcuts />

        <section id="about">
          <div className="container">
            <div className="about-content py-3">
              <h3 className="h1 text-body-emphasis fw-bold">Your One-Stop<br />Household Store</h3>
              <p className="text-muted">Phonics is the place where you can find all of your household needs. We offer General, Kitchen, Washroom & Bathroom stuff. We do not compromise on quanlity, our motive is to provide the best quality products at your doorstep.</p>

              <div className="row g-3">
                <div className="col-6">
                  <div className="card border-0 rounded-5">
                    <div className="card-body text-center p-3">
                      <img src="/general.png" alt="General" width="40%" />
                      <p className="lead text-dark fw-bold m-0 mt-2">General</p>
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <div className="card border-0 rounded-5">
                    <div className="card-body text-center p-3">
                      <img src="/kitchen.png" alt="Kitchen" width="40%" />
                      <p className="lead text-dark fw-bold m-0 mt-2">Kitchen</p>
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <div className="card border-0 rounded-5">
                    <div className="card-body text-center p-3">
                      <img src="/washroom.png" alt="Washroom" width="40%" />
                      <p className="lead text-dark fw-bold m-0 mt-2">Washroom</p>
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <div className="card border-0 rounded-5">
                    <div className="card-body text-center p-3">
                      <img src="/bathroom.png" alt="Bathroom" width="40%" />
                      <p className="lead text-dark fw-bold m-0 mt-2">Bathroom</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="about-image">
            <img src="/about.png" alt="About us" />
          </div>
        </section>

        <section id="contact">
          <div className="container py-5">
            <div className="d-block d-md-flex text-center text-md-start justify-content-between align-items-center">
              <div className="mb-3 mb-md-0">
                <h1 className="text-body-emphasis fw-bold m-0" id="contact">Contact us</h1>
                <p className="text-muted m-0">If you have any queries &amp; questions please feel free to ask us</p>
              </div>
              {/* <Link to="/complaint" className="btn btn-lg btn-theme"><i className="fas fa-triangle-exclamation me-2"></i> Report a Complaint</Link> */}
            </div>

            <div className="row g-3 my-3 text-center">
              <div className="col-md-6 col-lg-3">
                <div className="card border-0 rounded-5">
                  <div className="card-body">
                    <img src="/mobile.png" alt="Mobile Number" />
                    <h3 className="text-dark fw-bold mt-3">Mobile</h3>
                    <p><Link to="tel:03262023423" className="text-muted text-decoration-none">03262023423</Link></p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-3">
                <div className="card border-0 rounded-5">
                  <div className="card-body">
                    <img src="/email.png" alt="Eamil Address" />
                    <h3 className="text-dark fw-bold mt-3">Email</h3>
                    <p><Link to="mailto:info@phonicspk.com" className="text-muted text-decoration-none">info@phonicspk.com</Link></p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-3">
                <div className="card border-0 rounded-5">
                  <div className="card-body">
                    <img src="/website.png" alt="Website" />
                    <h3 className="text-dark fw-bold mt-3">Website</h3>
                    <p><Link to="https://phonicspk.com" className="text-muted text-decoration-none">phonicspk.com</Link></p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-3">
                <div className="card border-0 rounded-5">
                  <div className="card-body">
                    <img src="/social media.png" alt="Social Media" />
                    <h3 className="text-dark fw-bold mt-3">Social Media</h3>
                    <div className="d-flex gap-1 flex-row justify-content-center">
                      <Link to="https://www.facebook.com/PhonicsSoundsClean" className="text-muted text-decoration-none"><i className="fab fa-facebook"></i></Link>
                      <Link to="https://wa.me/923262023423" className="text-muted text-decoration-none"><i className="fab fa-whatsapp"></i></Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <section id="apps">
          <div className="container py-5">
            <div className="row g-3 align-items-center">
              <div className="col-lg-5 order-2 order-lg-1 text-center text-lg-start">
                <h1 className="display-4 fw-bold text-dark mb-3">Get in the rider's seat and <span className="text-theme">get paid</span></h1>
                <p className="text-muted mb-3">Join our rider team and enjoy freedom, flexibility, and instant earnings. Work full-time or part-time - it's your choice. With every delivery, you get quick payouts and the chance to turn your rides into real income.</p>

                <a href="/Phonics.apk" className="btn btn-lg p-3 px-5 btn-theme" download><i className="fab fa-google-play me-2"></i> Rider App</a>
              </div>
              <div className="col-lg-7 order-1 order-lg-2 text-center">
                <img src="/rider app.png" width="80%" />
              </div>
            </div>
          </div>
        </section> */}

        <section id="apps">
          <div className="container py-5 text-center">
            <div className="row g-3">
              <div className="col-lg-6">
                <div className="card border-0 rounded-5 h-100">
                  <div className="card-body p-5">
                    <h3 className="fw-bold text-dark mb-3">Join our <span className="text-theme">Rider's</span> team</h3>
                    <p className="text-muted mb-3">Ride with Phonics and earn more while delivering smarter. Our route optimization helps you spend less time finding your way and more time completing deliveries efficiently.</p>

                    <Link to="/Phonics.apk" className="btn btn-lg p-3 px-5 btn-theme" download><i className="fab fa-google-play me-2"></i> Rider App</Link>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="card border-0 rounded-5 h-100">
                  <div className="card-body p-5">
                    <h3 className="fw-bold text-dark mb-3">Get our <span className="text-theme">Customer</span> App</h3>
                    <p className="text-muted mb-3">From everyday cleaning essentials to household must-haves, Phonics brings the products you need right to your fingertips. Enjoy great deals, easy ordering, and the convenience of getting more done without leaving home.</p>

                    <button className="btn btn-lg p-3 px-5 btn-theme" disabled><i className="fab fa-google-play me-2"></i> Coming Soon</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </GuestLayout>
  )
}

export default Home
